import React from "react";

const ColDynamic = props => {
  return <div className={props.className}>{props.children}</div>;
};

export default ColDynamic;
